import { useContext, useEffect, useMemo, useState } from "react";
import { usePagination, useTable } from "react-table";
import { Get } from "../Rutas/ApiRest";
import "../index.css"
import { RastreoInicial } from "../Model/Tablas/RastreoCarga";
import { Contexto } from "../Context/Contexto";
import { Pagos } from "../Rutas/Servicios";
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext";
import { tokens } from "../Context/Tokens";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import axios from 'axios';
import { NotificacionesGeneral } from "../Context/Notificaciones_Context";


function PagosAnterior(prop:any)
{
    const {tok}=useContext(tokens)
    const {Cli}=useContext(Contexto)
    const {GuiaBusqueda}=useContext(GuiaBusquedaCont)
    const {SetLoading}=useContext(MensajeContActualizacion)
    const {NotifiContext}=useContext(NotificacionesGeneral)
    const lodash = require('lodash');
    const formatter = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 0
      })
      const formatterDolar = new Intl.NumberFormat('en-US', {style: 'currency',
      currency: 'USD',
        minimumFractionDigits: 2
      })
    
    const datos=[
        RastreoInicial
      ]
      const columns=useMemo(() => prop.Columna, [])
      const dato=useMemo(() => datos, [])
      const [data,Setdata]=useState(dato)
     useEffect(()=>{
        SetLoading(true)
        ActualizarDatos();
     },[Cli.Eleccion])


     useEffect(()=>{
        SetLoading(true)
        ActualizarDatos();
     },[GuiaBusqueda])

     const ActualizarDatos=()=>
     {
        if(Cli.lCasilla[Cli.Eleccion].ecode!=undefined)
        {
            if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {
                
                  axios( {
                    method: 'get',
                    url: prop.Link.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode).replace("@guiahija",GuiaBusqueda),
                    headers: { 
                      'Authorization': 'Bearer '+tok
                    }
                  })
                    .then(function (response:any) {
                    Setdata(response.data);
                    SetLoading(false)
                    })
                    .catch(function (error:any) {
                        Setdata([]);
                        SetLoading(false)
                    console.log(error);
                    });
                // const historialcargas=Get(prop.Link.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode).replace("@guiahija",GuiaBusqueda),"application/json",tok)
                // historialcargas.then(resultado=>{ Setdata(resultado);SetLoading(false)})
            }
        }
        
     }

     
      
          const { 
            getTableProps, 
        getTableBodyProps, 
        headerGroups, 
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        gotoPage,
        pageCount,
        state,
        prepareRow,
        } = useTable({
                // @ts-ignore
                columns,
                data,
            },
            usePagination
        );
        const { pageIndex } = state
    return (
        <>
             {data.length>0?<> <div className="row">
<div className="col-12 py-2 py-sm-0">
<div className="table-responsive" id="pagohistorial">
 <table  {...getTableProps()} className="table table-hover table-sm table-bordered">
   <thead style={{verticalAlign:"middle"}}>
       {headerGroups.map((headerGroup) => (
           <tr {...headerGroup.getHeaderGroupProps()}>
               {headerGroup.headers.map((column) => (
                   <th {...column.getHeaderProps()}>
                       {column.render('Header')}
                   </th>
               ))}
           </tr>
       ))}
   </thead>

   <tbody {...getTableBodyProps()} style={{verticalAlign:"top",textAlign:"center"}}>
       {page.map((row: any) => {
           prepareRow(row)
           return (
               <tr {...row.getRowProps()} style={{background:row.cells[0].value+""===GuiaBusqueda?"#00ad5f":"",color:row.cells[0].value+""===GuiaBusqueda?"#fff":""}}>
                   {row.cells.map((cell: any) => 
                   {
                    var datos="0";
                    var datosDolar="0"
                    if(cell.column.Header.includes("(Pesos)"))
                        {
                            try {
                                datos=formatter.format(cell.value)
                            } catch (error) {
                                datos=cell.value
                            }
                            
                        }
                        if(cell.column.Header.includes("(USD)"))
                            {
                                try {
                                    datosDolar=formatterDolar.format(cell.value)
                                } catch (error) {
                                    datosDolar=cell.value
                                }
                                
                            }
                       return (
                           cell.column.Header.includes("(Pesos)")?
                           <td {...cell.getCellProps()}>${datos}</td>:
                           cell.column.Header.includes("(USD)")?<td {...cell.getCellProps()}>USD{datosDolar}</td>:
                           cell.column.Header.includes("MIAMI/ESPAÑA")?<td {...cell.getCellProps()}>{cell.value!=undefined?cell.value.replace("T"," "):null}</td>:
                           <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                       );
                   })}
               </tr>
           );
       })}
   </tbody>
</table>   
</div>
</div>
</div>
{data.length>10?<div className="table-pagination" style={{margin: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

<a href={"#"+prop.Categoria}>
<button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-success">
                        Anterior
                    </button>
                   
                   
                </a>
                
                <span>
                    <strong style={{display: 'block', width: '100px', textAlign: 'center'}}>
                        {pageIndex + 1} / {pageOptions.length} 
                    </strong>
                </span>
                
                <a >
                <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-success" >
                        Siguiente
                    </button>
                    
                   
                   
                </a>

</div>:null}
<br/>
{data.length>0?lodash.sum(data.map((e:any)=>e.Total))>0?<div className="row">
    <h4> Total a Pagar (Pesos):${formatter.format(lodash.sum(data.map((e:any)=>e.Total)))}* </h4>
    <small>* Para visualizar descuentos o tarifas especiales debes pinchar "despacho a domicilio","prepago carga" o "retiro en oficina</small>
    <div className="col-sm-12">
        {NotifiContext[6]!=undefined?NotifiContext[6].cantidad>0?
        
        <div className="row">
            <div className="col-sm-4 my-1 px-sm-2">
            <a href={Pagos.PAgoPreAlertas.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode)} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}> <button className="btn btn-success"  >
                Pagar Guias
            </button></a>
            </div>
            
        </div> 
        :
        <div className="row">
        <div className="col-sm-4 my-1 px-sm-2">
        <a href={Pagos.despacho.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode)} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}> <button className="btn btn-success"  >
            Despacho a Domicilio
        </button></a>
        </div>
        <div className="col-sm-4 my-1 px-sm-2">
            <a href={Pagos.prepago.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode)} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}>  <button className="btn btn-success" >
        PrePago Carga
    </button></a> 
        </div>
        <div className="col-sm-4 my-1 px-sm-2">
            <a href={Pagos.retiro.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode)} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}>   <button className="btn btn-success" >
        Retiro Oficina
    </button></a>
        </div>
    </div> 
        
        :<div className="row">
        <div className="col-sm-4 my-1 px-sm-2">
        <a href={Pagos.despacho.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode)} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}> <button className="btn btn-success"  >
            Despacho a Domicilio
        </button></a>
        </div>
        <div className="col-sm-4 my-1 px-sm-2">
            <a href={Pagos.prepago.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode)} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}>  <button className="btn btn-success" >
        PrePago Carga
    </button></a> 
        </div>
        <div className="col-sm-4 my-1 px-sm-2">
            <a href={Pagos.retiro.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode)} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}>   <button className="btn btn-success" >
        Retiro Oficina
    </button></a>
        </div>
    </div> }
        

 
 
    </div>
   
</div>:null:null}

</>:<div><div className="alert au-alert-success alert-dismissible fade show au-alert au-alert--100per" role="alert" id={prop.Categoria}> <span className="content" >No existe ninguna guía para ser facturada. </span>

</div></div>
}



        </>
    )
}

export default PagosAnterior;